import React from 'react';
import Hidden from '@material-ui/core/Hidden';
import { Box } from '@material-ui/core';
import CmtImage from '../../../../@coremat/CmtImage';

const Logo = ({ color, ...props }) => {
  const logoUrl = color === 'white' ? '/images/logo-white.png' : '/images/logo.png';
  const logoSymbolUrl = color === 'white' ? '/images/logo-white-symbol.png' : '/images/logo-symbol.png';

  return (
    <Box {...props}>
      <Hidden xsDown>
        <CmtImage src={logoUrl} alt="logo" />
      </Hidden>
      <Hidden smUp>
        <CmtImage src={logoSymbolUrl} alt="logo" />
      </Hidden>
    </Box>
  );
};

export default Logo;
